import React from 'react';
import { result } from 'underscore';

import { formatChangeRatio, formatSearchInterest } from '../../utils/format';

export const SearchInterestColumn = ({ i18n }) => ({
  key: 'SearchInterest',
  name: i18n.getString(_TL_('Search interest')),
  fieldName: 'SearchInterest.CurrentValue',
  className: 'qi-column-search-interest',
  headerClassName: 'qi-header-search-interest',
  helpTopic: 'Pop_BA_SearchInsights_SearchInterest',
  minWidth: 150,
  sortable: true,
  isMultiline: true,
  isResizable: true,
  onRender: item => (
    <span>
      {i18n.getString(_TL_('{{value}} ({{ratio}})'), {
        value: formatSearchInterest(i18n, result(item.SearchInterest, 'CurrentValue')),
        ratio: formatChangeRatio(i18n, result(item.SearchInterest, 'ChangeRatio'), false) || i18n.getString(_TL_('>1000%')),
      })}
    </span>
  ),
});
